// extracted by mini-css-extract-plugin
export default {"cont":"Table_cont__qHg42","wider":"Table_wider__e89W4","table-wrapper":"Table_table-wrapper__PSbpq","table-container":"Table_table-container__nCXdY","noData":"Table_noData__mBcrG"};